import type { FC, ReactNode } from 'react'

import { contactFeatures, projectTypes } from '@/constants/content'
import { useContactForm } from '@/hooks/use-contact-form'

export const Booking: FC = (): ReactNode => {
    const { values, status, update, onSubmit } = useContactForm('Booking page')

    return (
        <section className='contact-section padding-bottom'>
            <div className='w-layout-blockcontainer hero-container small w-container'>
                <div className='section-content-wrapper'>
                    <div className='booking-contact-wrapper' data-reveal>
                        <div className='booking-left'>
                            <div className='hero-title-wrapper'>
                                <h2 className='booking-title'>
                                    No obligation, no pressure. Just honest pricing for quality work.
                                </h2>
                            </div>

                            <div className='contact-features'>
                                {contactFeatures.map((feature) => (
                                    <div key={feature.title} className='single-contact-features'>
                                        <img
                                            src='/images/check-circle-10-1.svg'
                                            loading='lazy'
                                            alt=''
                                            className='contact-feature-icon'
                                        />

                                        <div className='contact-feature-title-wrapper'>
                                            <p className='contact-feature-title'>
                                                {feature.title}
                                            </p>

                                            <p className='contact-feature-subtitle'>
                                                {feature.subtitle}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className='booking-area'>
                            <h3 className='booking-form-title'>
                                Request your free estimate
                            </h3>

                            <div className='contact-form w-form'>
                                <form name='booking-form' onSubmit={onSubmit} noValidate={false}>
                                    <div className='field-wrapper'>
                                        <div className='single-field-wrapper'>
                                            <label className='sr-only' htmlFor='booking-name'>
                                                Your name
                                            </label>

                                            <input
                                                id='booking-name'
                                                className='form-field w-input'
                                                type='text'
                                                name='name'
                                                autoComplete='name'
                                                placeholder='Your name'
                                                required
                                                value={values.name}
                                                onChange={(event) => update('name', event.target.value)}
                                            />
                                        </div>

                                        <div className='single-field-wrapper'>
                                            <label className='sr-only' htmlFor='booking-email'>
                                                Your email
                                            </label>

                                            <input
                                                id='booking-email'
                                                className='form-field w-input'
                                                type='email'
                                                name='email'
                                                autoComplete='email'
                                                placeholder='Your email'
                                                required
                                                value={values.email}
                                                onChange={(event) => update('email', event.target.value)}
                                            />
                                        </div>

                                        <div className='single-field-wrapper'>
                                            <label className='sr-only' htmlFor='booking-phone'>
                                                Phone number
                                            </label>

                                            <input
                                                id='booking-phone'
                                                className='form-field w-input'
                                                type='tel'
                                                name='phone'
                                                autoComplete='tel'
                                                placeholder='Phone number'
                                                value={values.phone}
                                                onChange={(event) => update('phone', event.target.value)}
                                            />
                                        </div>

                                        <div className='single-field-wrapper'>
                                            <label className='sr-only' htmlFor='booking-project'>
                                                Service needed
                                            </label>

                                            <select
                                                id='booking-project'
                                                className='form-field w-select'
                                                name='projectType'
                                                value={values.projectType}
                                                onChange={(event) => update('projectType', event.target.value)}
                                            >
                                                <option value=''>
                                                    Select a service…
                                                </option>

                                                {projectTypes.map((type) => (
                                                    <option key={type} value={type}>
                                                        {type}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className='single-field-wrapper'>
                                            <label className='sr-only' htmlFor='booking-date'>
                                                Preferred date
                                            </label>

                                            <input
                                                id='booking-date'
                                                className='form-field'
                                                type='date'
                                                name='preferredDate'
                                                value={values.preferredDate}
                                                onChange={(event) => update('preferredDate', event.target.value)}
                                            />
                                        </div>

                                        <button
                                            type='submit'
                                            className='booking-form-button w-button'
                                            disabled={status === 'sending'}
                                        >
                                            {status === 'sending' ? 'Sending…' : 'Get My Free Estimate'}
                                        </button>
                                    </div>
                                </form>

                                <div
                                    className={status === 'done' ? 'w-form-done is-visible' : 'w-form-done'}
                                    role='status'
                                    aria-live='polite'
                                >
                                    <div>
                                        Thank you! Your estimate request has been received. We will reach out within 24 hours.
                                    </div>
                                </div>

                                <div
                                    className={status === 'error' ? 'w-form-fail is-visible' : 'w-form-fail'}
                                    role='alert'
                                >
                                    <div>
                                        Oops! Something went wrong while submitting the form.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
